import * as React from 'react';
var Context = /*#__PURE__*/React.createContext({});
export default Context;